import { valueof } from 'src/Library/Types';
import * as partsConstants from '../../utils/partsToShow/partsConstants';
import * as sidebarSectionConstants from '../../utils/partsToShow/sidebarSectionConstants';

export const getSideMenuList: {
  id: valueof<typeof sidebarSectionConstants> | 'root';
  title?: string | string[];
  options: valueof<typeof partsConstants>[];
  description?: string;
}[] = [
  {
    id: sidebarSectionConstants.DASHBOARD,
    title: 'Dashboards',
    options: [],
  },
  {
    id: 'root',
    options: [partsConstants.PLAY],
  },
  {
    id: 'root',
    options: [partsConstants.EXCEPTION_RULES],
  },
  {
    id: sidebarSectionConstants.EXCEPTION_ALERTS,
    title: 'Exception Alerts',
    options: [partsConstants.EXCEPTION_ALERT_DEFINITIONS, partsConstants.EXCEPTION_ALERT_INSTANCES],
  },
  {
    id: sidebarSectionConstants.SHIPPING_MANAGEMENT,
    title: 'Track Shipments',
    options: [
      partsConstants.CONTAINER_TRACKING,
      partsConstants.IMPORTS,
      partsConstants.EXPORTS,
      partsConstants.AIR_CARGO,
      // partsConstants.SUMMARY_DASHBOARD,
    ],
    description:
      'A Real-time visibility tool. Track containers (BL, Booking, Container No.) and air shipments (AWB), view their location, milestones and delays',
  },
  {
    id: sidebarSectionConstants.TRIANGULATION,
    title: ['Container Triangulation'],
    options: [partsConstants.TRIANGULATION],
  },
  {
    id: sidebarSectionConstants.PROCURE,
    title: 'Rate Inquiry',
    options: [partsConstants.INQUIRY_SHIPPER],
    description:
      'Short-term request for rates. Use this module when you need freight rates for a single shipment or lane and run competitive bidding with vendors.',
  },
  {
    id: sidebarSectionConstants.QUOTE,
    title: 'Quote',
    options: [partsConstants.INQUIRY_FF],
    description:
      'Respond to shipper inquiries with quotes and manage bookings to secure deals',
  },
  {
    id: sidebarSectionConstants.DISCOVER_RATES,
    title: 'Contract Rates',
    options: [partsConstants.DISCOVER_SELL_RATES],
    description:
      'Live search & booking tool. Search confirmed rates, filter by route, carrier, validity, get trends & raise a booking request directly',
  },
  {
    id: sidebarSectionConstants.DISCOVER_RATES,
    title: 'Contract Rates',
    options: [partsConstants.DISCOVER_BUY_RATES],
    description:
      'Live search & booking tool. Search confirmed rates, filter by route, carrier, validity, get trends & raise a booking request directly',
  },
  {
    id: sidebarSectionConstants.DISCOVER_RATES,
    title: 'Contract Rates',
    options: [partsConstants.DISCOVER_RATES],
    description:
      'Live search & booking tool. Search confirmed rates, filter by route, carrier, validity, get trends & raise a booking request directly',
  },
  {
    id: sidebarSectionConstants.VESSEL_SCHEDULES,
    title: 'Vessel Schedules',
    options: [partsConstants.VESSEL_SCHEDULES],
    description: 'Check the global sailing schedules to plan your shipments',
  },
  {
    id: sidebarSectionConstants.INVOICE,
    title: 'Invoice',
    options: [partsConstants.PAYABLE, partsConstants.RECEIVABLE],
    description:
      'Manage Payables & Receivables: create, compare, approve, dispute, track all your invoices',
  },
  {
    id: sidebarSectionConstants.EXECUTION,
    title: 'Manage Tasks',
    options: [partsConstants.SHIP_EXEC_SHIPPER, partsConstants.SHIP_EXEC_VENDOR],
    description:
      'A workflow execution and compliance tool. Manage shipment tasks such as document uploads, approvals, and operational milestones',
  },
  {
    id: sidebarSectionConstants.RFQ,
    title: 'RFQ',
    options: [
      partsConstants.RFQ_SHIPPER_OCEAN_FREIGHT,
      partsConstants.RFQ_VENDOR,
      partsConstants.RFQ_SHIPPER_ANALYTICS,
      partsConstants.RFQ_RATE_MASTER,
      // partsConstants.RFQ_SHIPPING_LINE,
    ],
    description: 'Launch long-term or multi-lane RFQs. Use for bulk or quarterly/annual rate procurement, not single shipment requests',
  },
  {
    id: sidebarSectionConstants.NEW_IMPORTS,
    title: 'Imports',
    options: [partsConstants.IMPORTS_SALES_ORDER, partsConstants.IMPORTS_CONTAINER_TRACKING],
  },
  {
    id: sidebarSectionConstants.NEW_EXPORTS,
    title: 'Exports',
    options: [
      partsConstants.EXPORTS_RAKE,
      partsConstants.EXPORTS_SALES_ORDER,
      partsConstants.EXPORTS_CONTAINER_TRACKING,
    ],
  },
  {
    id: sidebarSectionConstants.DOMESTIC,
    title: 'Domestic',
    options: [
      partsConstants.DOMESTIC_TRACKING,
      partsConstants.DOMESTIC_CARRIER_MANAGEMENT,
      partsConstants.CUSTOMER_ACTIVITY,
    ],
  },
  {
    id: sidebarSectionConstants.RATE_MASTER,
    title: 'Rate Master',
    options: [partsConstants.RATE_MASTER],
    description:
      'A storage library for all rates. Use this module to upload and store offline rate sheets or view confirmed bids that are auto-captured into your system',
  },
  {
    id: sidebarSectionConstants.SETUP,
    title: 'Setup',
    options: [
      // partsConstants.SETUP_USERS,
      partsConstants.SETUP_TEAMS,
      partsConstants.SETUP_TNC,
      partsConstants.SETUP_CHARGE_MASTER,
      partsConstants.APPROVAL_POLICIES,
      partsConstants.MY_APPROVALS,
      partsConstants.RATE_MASTER,
      partsConstants.MARKUP_AUTOMATION_TOOL,
      partsConstants.DSR_TEMPLATES,
      partsConstants.REGIONS,
      partsConstants.DEMURRAGE_AND_DETENTION,
      partsConstants.MY_CHA,
      partsConstants.MY_CUSTOMER,
      partsConstants.MY_CHILD,
      partsConstants.MY_SUPPLIER,
      partsConstants.MY_FF,
      partsConstants.MY_SHIPPER,
      partsConstants.MY_SHIPPING_LINE,
      partsConstants.PRODUCT,
      partsConstants.ADDRESS,
      partsConstants.MY_DOCUMENTS,
      partsConstants.API,
      partsConstants.CUSTOM_CONFIG,
      partsConstants.BULK_REQUEST,
      partsConstants.TASKS_WORKFLOW,
      partsConstants.PORT_GROUPS
    ],
  },
  {
    id: sidebarSectionConstants.MY_ACCOUNT,
    title: 'Account',
    options: [
      partsConstants.MY_PROFILE,
      partsConstants.MY_ORGANISATION,
      partsConstants.SETUP_USERS,
      partsConstants.MY_SUBSCRIPTION_PLAN,
      partsConstants.LOGOUT,
    ],
  },
  {
    id: sidebarSectionConstants.ANALYTICS,
    title: 'Shipsy BI(Insights)',
    options: [partsConstants.ANALYTICS],
    description:
      'A business intelligence and analytics module. Use this to create and view dashboards, KPIs, and reports across inquiries, bookings, RFQs, shipments, and invoices'
  }
];
